import React, {Fragment} from 'react';
import { hashHistory } from 'react-router';
import {withRouter} from "react-router-dom";
import { connect } from "react-redux";
import SelectionWindowBvRequests from "./selectionWindowBvRequests";
import debounce from "lodash/debounce";
import $ from "jquery";

import {
  toggleSelectionWindow, toggleSelectionFeatureInfo, setCameFromPage, changeActivePartRelatedItemIndex,
  setQtActiveCategory, toggleBathroomVisualizerOpen, setActiveFeature
} from "../../actions/actionFunctions";

import DesktopHeader from '../desktopHeader';
import SelectionMain from './selectionMain';
import SelectionFooter from './selectionFooter';
// import SelectionVanityChoose from './selectionVanityChoose';
// import SelectionShowerChoose from './selectionShowerChoose';
// import MaterialsPageTutorial from '../tutorials/materialsPageTutorial';
import MaterialsAgentTutorial from '../tutorials/materialsAgentTutorial';
import {changeRoutePath, changeQTRoutePath} from "../../misc/changeRoutePath";

import {getCurrentLayout} from "../appLayout";
import Filters from './../visComponents/navigation/newFilters/filters';
import {showMaterialsTutorial} from "../../actions/tutorialFunctions";
// import Config from "../../config";
import {PartMenuType} from "../visComponents/constants";
import ActionTypes from "../../misc/actionTypes";
import NavItemPositionModal from "../visComponents/navigation/navItemPositionModal";
import {setRowItems} from "../../actions/selectionFunctions";
import {COUNTERTOP_GROUP} from "../kvComponent/core/constants";
import {subPartIsDone} from "./subPartDoneCheckMark";
import {setInitialFlowRoom, setInitialFlowVisualizerNotAvailable} from "../../actions/initialFlowFunctions";
import {
  getVisualizerTypeFromSubscription,
  hasSubscriptionForRoom,
  switchToNewVisualizerType
} from "../../misc/visualizerSwitchingFunctions";
import {searchProductRequest} from "../../api/search-api";
import {capitalizeFirstLetters} from "../../misc/utils";
import {
  featureIsMatchingQtCatName,
  getCurrentQuoteRoomCartItem,
  getRoomNameToCompare
} from "../../misc/categorySwitchingFunctions";
import {removeLoadingElements} from "../../loadingLogic";
import {USE_NEW_CANVAS} from "../../config";

const historyUpdateTimeout = window.navigator
&& window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1 ? 150 : 0;

class SelectionMainWindow extends SelectionWindowBvRequests {

  constructor(props) {
    super(props);
    this.state = {
      activePart: null,
      searchText: "",
      searchRequest: false,
    };
    this._isMounted = false;
    this._partIdRequestsMade = [];
    this._filtersRequestsMade = [];
  }

  componentDidUpdate() {
    if (this.props.selectionOpened) {
      document.body.classList.add('body--materials');
    }
  }

  componentDidMount() {
    const layout = getCurrentLayout();
    this._isMounted = true;
    const selectionGroup = this.props.selectionGroup;
    this.setState({
      activePart: layout.parts[selectionGroup]
    }, () => {
      let realSubPart = this.getActiveChildPart();
      if (realSubPart) {
        this.getSubPartFeatures(realSubPart);
      }
    });
    if (!layout.qtCategories) {
      this.unlisten = hashHistory.listen(this.hashHistoryListener);
      this.hashHistoryListener();
    } else {
      const nextCategory = layout.qtCategories[0];
      if (nextCategory && !this.props.qtActiveCategory) {
        this.listenToRouteChangeForQtCategories(true)
      }
      this.unlisten = hashHistory.listen(this.hashHistoryListener);
    }
    if (!this.props.selectionOpened) {
      if (!layout.qtCategories) {
        const partName = this.props.match.params.partName;
        const existingSelGroup = this.props.layoutParts.find(selGroup => selGroup.toLowerCase() === partName);
        this.props.toggleSelectionWindow(true, existingSelGroup && this.props.selectionGroup !== existingSelGroup
          ? existingSelGroup
          : this.props.selectionGroup || this.props.layoutParts[0]);
      } else {
        this.props.toggleSelectionWindow(true, this.props.selectionGroup || this.props.layoutParts[0]);
      }
    }
    $(window).on(ActionTypes.UPDATE_QUOTING_TOOL, this.updateComponent);
    // if (!this.props.materialsTutorialFinished) {
    //   this.props.showMaterialsTutorial(true);
    // }
    if (window.location.hash.includes("visualizer") && !this.props.bvOpened) {
      this.props.toggleBathroomVisualizerOpen(true);
      this.props.toggleSelectionWindow(false);
    }
    if (window.location.hash.includes("materials")) {
      removeLoadingElements("MaterialsComponent");
    }
    // this.props.changeActivePartRelatedItemIndex(null);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const layout = getCurrentLayout();
    if (nextProps.selectionGroup && (this.props.selectionGroup !== nextProps.selectionGroup) && !window.location.hash.includes("visualizer")) {
      this.changeActivePart(nextProps.selectionGroup)
    }
    if ((nextProps.activePartRelatedItemIndex || nextProps.activePartRelatedItemIndex === 0)
      && this.props.activePartRelatedItemIndex !== nextProps.activePartRelatedItemIndex && !window.location.hash.includes("visualizer")) {
      if (layout.qtCategories) {
        this.updateQtRoutePath(nextProps);
      } else {
        changeRoutePath(this.state.activePart, nextProps.activePartRelatedItemIndex, false);
      }
    }
    if (layout.qtCategories && (nextProps.qtActiveCategory !== this.props.qtActiveCategory) && !window.location.hash.includes("visualizer")) {
      this.updateQtRoutePath(nextProps);
    } else if (!nextProps.bvOpened && this.props.bvOpened && !layout.qtCategories) {
      this.changeActivePart(nextProps.selectionGroup);
    }
  }

  updateQtRoutePath = (nextProps) => {
    const layout = getCurrentLayout();
    const nextSubPart = changeQTRoutePath(nextProps.qtActiveCategory, nextProps.activePartRelatedItemIndex);
    if (!layout.qtCategories) {
      return
    }
    if (nextSubPart) {
      this.getSubPartFeatures(nextSubPart);
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
    this.unlisten();
    $(window).off(ActionTypes.UPDATE_QUOTING_TOOL, this.updateComponent);
    this.props.setRowItems([]);
  }

  listenToRouteChangeForQtCategories = (firstLoad) => {
    if (this.props.match && this.props.match.params && this.props.match.params.partName) {
      const {partName, subPartName} = this.props.match.params;
      const layout = getCurrentLayout();
      const nextCategory = layout.qtCategories[0];
      const qtCategoryIndexFromUrl = layout.qtCategories.findIndex(qtCategory => {
        return qtCategory.name.replace(/ /g,"-").replace(/\//g,"-").toLowerCase() === partName
      });
      const qtCategory = layout.qtCategories[qtCategoryIndexFromUrl];
      const nextCatName = qtCategory ? qtCategory.name : nextCategory.name;
      this.props.setQtActiveCategory(nextCatName);

      this.checkIfNeedToSwitchRoom(null, nextCatName);

      if (subPartName && qtCategory) {
        const subPartsMatching = qtCategory.subParts.filter(subPart => { // same filter groups under one category
          return subPart.part.partName.replace(/ /g,"-").toLowerCase() === subPartName
        });
        if (subPartsMatching.length) {
          let subPartIndexFromUrl = qtCategory.subParts.findIndex(subPart => {
            return subPart.part.partName.replace(/ /g,"-").toLowerCase() === subPartName
          });
          if (subPartsMatching.length > 1) { // same filter groups under one category
            const subPartIndexFromUrlTest = qtCategory.subParts.findIndex((subPart, subPartIndex) => {
              return (subPart.part.partName.replace(/ /g,"-").toLowerCase() === subPartName)
                && (subPartIndex === this.props.activePartRelatedItemIndex)
            });
            if (subPartIndexFromUrlTest > -1) {
              subPartIndexFromUrl = subPartIndexFromUrlTest;
            }
          }
          this.props.changeActivePartRelatedItemIndex(subPartIndexFromUrl);
        }
      }
    } else if (firstLoad) {
      this.setFirstAvailableCategory();
    }
  };

  setFirstAvailableCategory = (setFirstRoute = false) => {
    const layout = getCurrentLayout();
    if (!layout.qtCategories) {
      this.props.changeActivePartRelatedItemIndex(0);
      hashHistory.push("/materials");
      return
    }
    const qtActiveCategory = layout.qtCategories[0].name;
    this.props.setQtActiveCategory(qtActiveCategory);
    if (setFirstRoute) {
      this.updateQtRoutePath({
        qtActiveCategory,
        activePartRelatedItemIndex: 0
      })
    }
  }

  runActionAfterVisualizerChange = (actionAfterRoomChange) => {
    const {setQtActiveCategory, setActiveFeature, activeQuoteIndex} = this.props;
    const layout = getCurrentLayout();
    console.log("actionAfterRoomChange", actionAfterRoomChange);
    if (actionAfterRoomChange.type === "featureClick") {
      this.setFirstAvailableCategory(true);
      const childItem = this.getActiveChildPart();
      if (childItem && childItem.part && actionAfterRoomChange.feature) {
        childItem.part.activeFeature = actionAfterRoomChange.feature;
        childItem.part.firstClick[activeQuoteIndex] = true;
        setActiveFeature(actionAfterRoomChange.feature);
      }
    } else if (actionAfterRoomChange.type === "categoryChange" && layout.qtCategories) { //todo to test if this is needed
      const existingCategory = layout.qtCategories.find(qtCategory => qtCategory.name === actionAfterRoomChange.categoryName);
      if (existingCategory) {
        setQtActiveCategory(actionAfterRoomChange.categoryName);
        this.changeActivePartRelatedItem(0);
      } else {
        this.setFirstAvailableCategory(true);
      }
    }
  }

  checkIfNeedToSwitchRoom = async (featureClicked = null, nextCategoryName = "") => {
    const {fabricatorData, visualizerIsChanging} = this.props;
    if (!fabricatorData.settings.allowVisualizerSwitching || visualizerIsChanging) {
      return false
    }

    let room = featureClicked ? getRoomNameToCompare(featureClicked) : capitalizeFirstLetters(nextCategoryName); // kitchen -> Kitchen

    // 1) set selected room
    this.props.setInitialFlowRoom(room);
    // 2) if user clicked on unavailable visualizer -> go and set initial visualizer!
    const hasSubscription = hasSubscriptionForRoom(room);
    if (hasSubscription) {
      if (this.props.visualizerNotAvailable) { // cases when someone returns back
        this.props.setInitialFlowVisualizerNotAvailable(false);
      }
    } else {
      if (!fabricatorData.settings.useCategorySwitching) {
        this.props.setInitialFlowVisualizerNotAvailable(true);
      }

      const layout = getCurrentLayout();
      const roomFeatureGroup = layout.getFeatureGroupByPartId("room");
      if (roomFeatureGroup && roomFeatureGroup.features.some(feature => feature.dbFeature.sharedFeatureName === room)) {
        room = this.props.initialVisualizerType; // set the first loaded visualizer // only if category is a room!
      }
      // const kitchenSubscription = fabricatorSubscriptions.find(subscription => subscription && subscription.service.toLowerCase() === "kitchen");
      // room = kitchenSubscription
      //   ? document.kvConfig.toolVersion === 5 ? AVAILABLE_VISUALIZER_TYPES.kvScene : AVAILABLE_VISUALIZER_TYPES.Kitchen
      //   : document.kvConfig.toolVersion === 5 ? AVAILABLE_VISUALIZER_TYPES.bvScene : AVAILABLE_VISUALIZER_TYPES.Bathroom;
    }
    // 3) set main config visualizer type
    const newVisualizerType = hasSubscription ? getVisualizerTypeFromSubscription(hasSubscription) : null;
    if (newVisualizerType && (document.kvConfig.visualizerType !== newVisualizerType)) {
      await switchToNewVisualizerType(newVisualizerType);
      const actionAfterRoomChange = {
        type: featureClicked ? "featureClick" : "categoryChange",
        feature: featureClicked,
        categoryName: nextCategoryName,
      }
      this.runActionAfterVisualizerChange(actionAfterRoomChange);
    }
  }

  hashHistoryListener = (listenerObject = false) => {
    // if (Config.isDevMode()) {
    //   console.log("listenerObject", listenerObject);
    // }
    setTimeout(() => {
      const layout = getCurrentLayout();
      if (layout.qtCategories) {
        this.listenToRouteChangeForQtCategories();
      } else {
        const {partName, subPartName} = this.props.match.params;

        // 1) set Parent if we clicked back button
        const selectionGroup = this.props.selectionGroup;
        const existingSelGroup = this.props.layoutParts.find(selGroup => selGroup.toLowerCase() === partName);
        if (existingSelGroup && this.props.selectionGroup !== existingSelGroup && listenerObject) {
          this.props.toggleSelectionWindow(true, existingSelGroup);
        }
        if (existingSelGroup && selectionGroup.toLowerCase() !== partName) {
          this.changeActivePart(existingSelGroup, false)
        }

        // 2) set Child if we clicked back button

        if (this.state.activePart) {
          const subParts = this.state.activePart.subParts(false);
          const nextSubPartIndex = subParts.findIndex(subPart => {
            const thisPartName = subPart.part.partName.toLowerCase().replace(" ","-");
            return thisPartName === subPartName
          });
          if (nextSubPartIndex > -1 && nextSubPartIndex !== this.props.activePartRelatedItemIndex) {
            // console.log('subParts', subParts);
            // console.log('nextSubPartIndex', nextSubPartIndex);
            // console.log('this.props.activePartRelatedItemIndex', this.props.activePartRelatedItemIndex);
            this.changeActivePartRelatedItem(nextSubPartIndex, false)
          }
        }
      }

      if (listenerObject) {
        if (listenerObject.pathname.includes("visualizer")) {
          this.props.toggleBathroomVisualizerOpen(true);
        } else {
          this.props.toggleBathroomVisualizerOpen(false);
        }
      }

    }, historyUpdateTimeout)
  };

  getSubPartFeatures = (activeSubPart) => {
    const requestName = document.kvConfig.visualizerType + "_" + activeSubPart.part.partId;
    if (!this._partIdRequestsMade.includes(requestName)) {
      this.checkIfAllFeaturesReceived(activeSubPart, "", null, true);
      this._partIdRequestsMade.push(requestName);
    }
    if (!this._filtersRequestsMade.includes(activeSubPart.part.partId) && COUNTERTOP_GROUP.includes(activeSubPart.part.partId)
      && !activeSubPart.filtersReceived) {
      this._filtersRequestsMade.push(activeSubPart.part.partId);
      this.checkIfAllFiltersReceived(activeSubPart.part, this.props.filterGroups)
        .then(() => {
          if (this._isMounted) {
            this.forceUpdate()
          }
        });
    }
  };

  changeActivePart = (nextSelGroup) => {
    const layout = getCurrentLayout();
    const activePart = layout.parts[nextSelGroup];
    this.props.changeActivePartRelatedItemIndex(0);
    this.setState({
      activePart,
      searchText: ""
    }, () => {
      const listContainer = document.querySelector('.bv-item-list');
      if (listContainer) {
        listContainer.scrollLeft = 0;
      }
      if ((activePart.partName === "Ceiling" &&
        (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV")) || activePart.partName === "Floor" || activePart.partName === "Window" || activePart.partName === "Toilet") {
        const navItemParent = {
          part: activePart.partName === "Toilet" ? activePart.toilet : activePart,
          text: activePart.partName
        };
        this.getSubPartFeatures(navItemParent);
      } else {
        const relatedNavItem = activePart.subParts(false)[0];
        this.getSubPartFeatures(relatedNavItem);
      }
    });
  };

  changeActivePartRelatedItem = (activePartRelatedItemIndex, fromButton = "") => {

    // console.log('activePartRelatedItemIndex', activePartRelatedItemIndex);
    const layout = getCurrentLayout();
    this.setState({
      searchText: ""
    });

    if (layout.qtCategories && this.props.qtActiveCategory) {
      const qtActiveCategory = layout.qtCategories.find(qtCategory => qtCategory.name === this.props.qtActiveCategory);
      if (fromButton === "nextButton" || fromButton === "addToCartButton") {
        const checkForCheckedStep = () => {
          activePartRelatedItemIndex = activePartRelatedItemIndex <= 0 ? 0 : activePartRelatedItemIndex;
          const relatedNavItem = qtActiveCategory.subParts[activePartRelatedItemIndex];
          return relatedNavItem && relatedNavItem.part && subPartIsDone(relatedNavItem.part, this.props.activeQuoteIndex, this.props.cartItems)
        }
        while (activePartRelatedItemIndex <= qtActiveCategory.subParts.length - 1) {
          if (!checkForCheckedStep()) {
            break;
          }
          // console.log("activePartRelatedItemIndex skipped", activePartRelatedItemIndex);
          activePartRelatedItemIndex = activePartRelatedItemIndex + 1;
        }
      }

      if (activePartRelatedItemIndex > qtActiveCategory.subParts.length - 1) { // next parent
        const {fabricatorData} = this.props;
        const activePartIndex = layout.qtCategories.findIndex(qtCategory => qtCategory.name === this.props.qtActiveCategory);

        let nextCategory = layout.qtCategories[activePartIndex+1];
        let switchToDirectCategory = null;

        if (fabricatorData.settings.useCategorySwitching
          && qtActiveCategory.subParts
          && qtActiveCategory.subParts[this.props.activePartRelatedItemIndex]
          && qtActiveCategory.subParts[this.props.activePartRelatedItemIndex].part.partId === "room") {
          const addedRoom = getCurrentQuoteRoomCartItem(this.props.cartItems, this.props.activeQuoteIndex);
          if (addedRoom && addedRoom.cartFeature) {
            switchToDirectCategory = layout.qtCategories.find(qtCategory => featureIsMatchingQtCatName(addedRoom.cartFeature, qtCategory.name, true))
            if (nextCategory) {
              if (switchToDirectCategory) {
                nextCategory = switchToDirectCategory;
              }
              this.checkIfNeedToSwitchRoom(addedRoom.cartFeature, nextCategory.name);
              // // here we might need to check if a visualizer type change needed, but there is no need for now
            }
          }
        }
        // if (nextCategory && !(fabricatorData.settings.useCategorySwitching && staticCanvasImage && !switchToDirectCategory)) { // not sure why do we need that! there is no sense
        if (nextCategory) {
          this.props.setQtActiveCategory(nextCategory.name);
          this.props.changeActivePartRelatedItemIndex(0);
        } else {
          this.closeSelectionWindow('shoppingcart');  // go to the shopping cart after wizard is finished
        }
      } else if (activePartRelatedItemIndex < 0) { // prev parent
        const activePartIndex = layout.qtCategories.findIndex(qtCategory => qtCategory.name === this.props.qtActiveCategory);
        if (this.props.layoutParts[activePartIndex-1]) {
          this.props.setQtActiveCategory(layout.qtCategories[activePartIndex-1].name);
        } else {
          this.handleCloseClick();
        }
      } else { // change child
        const nextRelatedItemIndex = activePartRelatedItemIndex <= 0 ? 0 : activePartRelatedItemIndex;
        this.props.changeActivePartRelatedItemIndex(nextRelatedItemIndex);
        const relatedNavItem = qtActiveCategory.subParts[nextRelatedItemIndex];
        setTimeout(() => {
          this.getSubPartFeatures(relatedNavItem);
          const listContainer = document.querySelector('.bv-item-list');
          if (listContainer) {
            listContainer.scrollLeft = 0;
          }
        }, 0);
      }
    } else {
      if (activePartRelatedItemIndex > this.state.activePart.subParts(false).length - 1) { // next parent
        const activePartIndex = this.props.layoutParts.findIndex(part => part === this.props.selectionGroup);
        const nextSelGroup = this.props.layoutParts[activePartIndex+1];
        if (nextSelGroup) {
          this.props.toggleSelectionWindow(true, nextSelGroup);
          this.props.changeActivePartRelatedItemIndex(0);
        } else {
          this.closeSelectionWindow('shoppingcart');  // go to the shopping cart after wizard is finished
          // this.handleCloseClick();
        }
      } else if (activePartRelatedItemIndex < 0) { // prev parent
        const activePartIndex = this.props.layoutParts.findIndex(part => part === this.props.selectionGroup);
        if (this.props.layoutParts[activePartIndex-1]) {
          this.props.toggleSelectionWindow(true, this.props.layoutParts[activePartIndex-1]);
        } else {
          this.handleCloseClick();
        }
      } else { // change child
        const nextRelatedItemIndex = activePartRelatedItemIndex <= 0 ? 0 : activePartRelatedItemIndex;
        this.props.changeActivePartRelatedItemIndex(nextRelatedItemIndex);
        const relatedNavItem = this.state.activePart.subParts(false)[nextRelatedItemIndex];
        setTimeout(() => {
          this.getSubPartFeatures(relatedNavItem);
          const listContainer = document.querySelector('.bv-item-list');
          if (listContainer) {
            listContainer.scrollLeft = 0;
          }
        }, 0);
      }
    }

    this.props.setRowItems([]);
  };

  handleCloseClick = (url) => {
    if (this.props.selectionFeatureInfo) {
      this.props.toggleSelectionFeatureInfo(null);
    } else {
      this.closeSelectionWindow(url);
    }
  };

  closeSelectionWindow = (url) => {
    this.props.toggleSelectionWindow(false, this.props.selectionGroup);
    if (url === 'shoppingcart') {
      this.props.setCameFromPage('materials');
      hashHistory.push('shoppingcart');
    } else {
      document.body.classList.remove('body--materials');
      hashHistory.push('quote-design');
    }
  };

  getSearchProducts = async (searchText) => {
    if (searchText) {
      const childItem = this.getActiveChildPart().part;
      await searchProductRequest(childItem, searchText, (searchRequest) => {
        if (this._isMounted) {
          this.setState({searchRequest})
        }
      })
      if (this._isMounted) {
        this.forceUpdate()
      }
    }
  };

  searchAPIDebounced = debounce(this.getSearchProducts, 500);

  handleSearchInputChange = async (event) => {
    const searchText = event.target.value;
    this.setState({
      searchText
    });
    await this.searchAPIDebounced(searchText);
  };

  updateComponent = () => {
    this.forceUpdate();
  };

  getActiveChildPart = () => {
    const layout = getCurrentLayout();
    if (layout.qtCategories && this.props.qtActiveCategory) {
      let qtActiveCategory = layout.qtCategories.find(qtCategory => qtCategory.name === this.props.qtActiveCategory);
      if (!qtActiveCategory) {
        qtActiveCategory = layout.qtCategories[0];
        setTimeout(() => {
          this.props.setQtActiveCategory(qtActiveCategory.name);  // cases when visualizerType is changed
        }, 0)
      }
      return qtActiveCategory.subParts[this.props.activePartRelatedItemIndex] || qtActiveCategory.subParts[0];
    } else {
      // const subParts = this.state.activePart.subParts(); // all with hidden
      // const relatedNavItem = subParts[this.props.activePartRelatedItemIndex];
      if (!this.state.activePart) {
        return null
      }
      const realSubParts = this.state.activePart.subParts(false); // without hidden
      return realSubParts[this.props.activePartRelatedItemIndex];
      // return realSubParts.find(sPart => sPart.part.partId === relatedNavItem.part.partId);
    }
  };

  getFeatures = (activeSubPart, layout) => {
    if (this.state.activePart && (activeSubPart || this.state.activePart.menuType === PartMenuType.Simple)) {
      const parentItem = {part: this.state.activePart};
      const currentParent = (parentItem.part.menuType === PartMenuType.Simple) ? parentItem : activeSubPart;
      return layout.designNavigationItems(
        currentParent,
        this.props.selectedFilters,
        this.state.searchText,
        false,
        true,
        this.props.filterGroups,
        {forActiveQTCategory: this.props.qtActiveCategory}
      );
    }
    return []
  };

  render() {

    const layout = getCurrentLayout();
    let activeSubPart = {};
    if (this.state.activePart) {
      activeSubPart = this.getActiveChildPart();
    }

    const features = this.getFeatures(activeSubPart, layout);

    // console.log("activePart", this.state.activePart);
    // console.log("activeSubPart", activeSubPart);
    // console.log("features", features);
    // console.log("this.props.selectionGroup", this.props.selectionGroup);
    // console.log("this.props.selectionOpened", this.props.selectionOpened);

    return this.props.selectionOpened && this.props.selectionGroup && this.state.activePart ? (
      <Fragment>
        <div className={USE_NEW_CANVAS ? "h-full w-full" : "overlay overlay--white"}>
          <div className={"selection selection--opened"
            + (USE_NEW_CANVAS && this.props.bvOpened ? " visibility-hidden" : "")}>
            <div className="materials">
              <DesktopHeader uploadsAndNotes={false}/>
              {activeSubPart ? (
                <SelectionMain features={features}
                               searchRequest={this.state.searchRequest}
                               searchText={this.state.searchText}
                               handleSearchInputChange={this.handleSearchInputChange}
                               activePart={this.state.activePart}
                               activeSubPart={activeSubPart}
                               handleCloseClick={this.handleCloseClick}
                               changeActivePartRelatedItem={this.changeActivePartRelatedItem}
                               parentUpdate={this.updateComponent}
                               checkIfNeedToSwitchRoom={this.checkIfNeedToSwitchRoom}/>
              ) : null}
              <SelectionFooter activePart={this.state.activePart}
                               activeSubType_={this.state.activePart.activeSubType_}
                               changeActivePartRelatedItem={this.changeActivePartRelatedItem}
                               activeSubPart={activeSubPart}
                               handleCloseClick={this.handleCloseClick}/>
            </div>
          </div>
          <Filters
            id="selectionWindow"
            searchText={this.state.searchText}
            handleSearchInputChange={this.handleSearchInputChange}
            layout={layout}
            childItem={activeSubPart}/>
          {/*{this.props.materialsTutorialIsOpened && !this.props.materialsTutorialFinished && !Config.isDevMode() ? <MaterialsPageTutorial/> : null}*/}
          <MaterialsAgentTutorial/>
        </div>
        {this.props.bvOpened ? null : <NavItemPositionModal/>}
      </Fragment>
    ) : null;
  }
}

const mapStateToProps = (store) => {
  const {windowWidth, visualizersLoaded, initialVisualizerType, visualizerIsChanging} = store.serverState;
  const {selectionOpened, selectionGroup, activePartRelatedItemIndex, selectionFeatureInfo} = store.selectionState;
  // const {materialsTutorialIsOpened, materialsTutorialFinished} = store.tutorialState;
  const {activeQuoteIndex} = store.quotesState;
  const {cameFromPage, cartItems} = store.cartState;
  const {visualizerNotAvailable} = store.initialFlowState;
  const {bvOpened, staticCanvasImage} = store.bathroomVisualizerState;
  return {
    selectionOpened,
    selectionGroup,
    activePartRelatedItemIndex,
    selectionFeatureInfo,
    windowWidth,
    bvOpened,
    staticCanvasImage,
    layoutParts: store.stepsState.layoutParts,
    cameFromPage,
    selectedFilters: store.filterState.selectedFilters,
    qtActiveCategory: store.qtState.qtActiveCategory,
    // materialsTutorialIsOpened,
    // materialsTutorialFinished,
    filterGroups: store.filterState.filterGroups,
    activeQuoteIndex,
    cartItems,
    visualizersLoaded,
    fabricatorData: store.fabricatorState,
    visualizerNotAvailable,
    initialVisualizerType,
    visualizerIsChanging,
  };
};

export default withRouter(connect(mapStateToProps, {
  toggleSelectionWindow,
  toggleSelectionFeatureInfo,
  setCameFromPage,
  changeActivePartRelatedItemIndex,
  setQtActiveCategory,
  showMaterialsTutorial,
  toggleBathroomVisualizerOpen,
  setRowItems,
  setInitialFlowRoom,
  setInitialFlowVisualizerNotAvailable,
  setActiveFeature,
})(SelectionMainWindow));
